/* eslint-disable react/prop-types */
// if privacy policy agreement is requred see commit:
// https://softwarehut.visualstudio.com/DefaultCollection/Zonifero.WWW/_git/Zonifero.WWW/commit/52b0ba021a24d6bc2ea1910d4d60af104f948a46?refName=refs%2Fheads%2Ffeature%2F76983-add-contact-form-support
// and add commented out lines
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { Column, Row } from 'hedron';
import { ContactFormSupport as ContactFormSupportModel } from 'models';
import Container from 'blocks/Container/Container';
import CustomCheckbox from 'blocks/Form/CustomCheckbox';
import CustomForm from 'blocks/Form/CustomForm';
import CustomFormElement from 'blocks/Form/CustomFormElement';
import SubmitButton from 'blocks/Form/SubmitButton';

import { Bind } from 'lodash-decorators';


import MailingService from 'services/Mailing.service';
import FORM from 'common/consts/form';


import ds from 'designsystem';
import HTMLModifiableBackground from 'blocks/HTMLModifableBackground/HTMLModifiableBackground';

@inject('appStore')

@observer
class ContactFormSupport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        system: [],
        body: '',
        email: '',
        firstName: '',
        lastName: '',
        phone: '',
        company: '',
        osVersion: '',
        dataProcessingCheckbox: false,
        dataSendingCheckbox: false,
      },
      buttonState: '',
      resetValue: false,
    };
  }

  @Bind
  async submitForm(submitEvent) {
    submitEvent.preventDefault();
    const {
      appStore: {
        referrer,
        currentUrl,
        previousUrl,
      },
    } = this.props;
    const {
      formData: {
        firstName,
        lastName,
        phone,
        email,
        body,
        company,
        osVersion,
        system,
      },
    } = this.state;

    try {
      this.setState({
        buttonState: FORM.BUTTON_STATE.LOADING,
      });

      fetch(process.env.REACT_APP_GEOLOCATION_API)
        .then(response => response.json())
        .then(jsonResponse => this.setState({country: jsonResponse.country}));

      const data = {
        firstName,
        lastName,
        phone,
        email,
        body,
        company,
        system,
        osVersion,
        source: referrer,
        url: currentUrl,
        referrer: previousUrl,
      };
      
      await MailingService.sendContactSupportForm(data);
      
      this.setState({
        buttonState: FORM.BUTTON_STATE.SUCCESS,
      });

      setTimeout(() => {
        this.resetState();
      }, FORM.SUCCESS_MESSAGE_TIMEOUT);

      this.setState({
        resetValue: false,
      });
    } catch (e) {
      this.setState({
        buttonState: FORM.BUTTON_STATE.ERROR,
      });
    }
  }

  resetState() {
    this.setState({
      formData: {
        system: [],
        body: '',
        company: '',
        osVersion: '',
        email: '',
        firstName: '',
        lastName: '',
        phone: '',
        dataProcessingCheckbox: false,
        dataSendingCheckbox: false,
      },
      buttonState: '',
      resetValue: true,
    });
  }

  @Bind
  updateInputValue(input) {
    const { inputName } = input;
    const { formData } = this.state;

    formData[inputName] = input.value;

    this.setState({ formData });
  }

  @Bind
  updateGroupInputValue(input) {
    const { inputName, value } = input;
    const { formData } = this.state;

    if (!formData.system.includes(inputName) && value) {
      formData.system.push(inputName);
    }

    if (formData.system.includes(inputName) && !value) {
      formData.system = formData.system.filter(item => item !== inputName);
    }

    this.setState({ formData });
  }

  render() {
    const {
      data: {
        clientSystem,
        company,
        osVersion,
        emailLabel,
        firstNameLabel,
        lastNameLabel,
        phoneLabel,
        messageLabel,
        htmlModifiers,
      },
    } = this.props;

    const { buttonState, resetValue } = this.state;

    return (
      <HTMLModifiableBackground
        htmlModifiers={htmlModifiers}
        color={ds.brand('white')}
      >
        <CustomForm onSubmit={this.submitForm} className="GA-form-contact">
          <Container>
            <Row divisions={11}>
              <Column lg={5}>
                <CustomFormElement
                  type="text"
                  name="firstName"
                  required
                  labelName={firstNameLabel}
                  validateOnInput
                  getValue={this.updateInputValue}
                  resetValue={resetValue}
                />
              </Column>
              <Column lg={5} lgShift={1}>
                <CustomFormElement
                  type="text"
                  name="lastName"
                  required
                  labelName={lastNameLabel}
                  validateOnInput
                  getValue={this.updateInputValue}
                  resetValue={resetValue}
                />
              </Column>
            </Row>
            <Row divisions={11}>
              <Column lg={5}>
                <CustomFormElement
                  type="tel"
                  name="phone"
                  pattern="^[0-9-+\s()]*$"
                  labelName={phoneLabel}
                  validateOnInput
                  getValue={this.updateInputValue}
                  resetValue={resetValue}
                />
              </Column>
              <Column lg={5} lgShift={1}>
                <CustomFormElement
                  type="email"
                  name="email"
                  required
                  labelName={emailLabel}
                  validateOnInput
                  getValue={this.updateInputValue}
                  resetValue={resetValue}
                />
              </Column>
            </Row>
            <Row divisions={11}>
              <Column lg={5}>
                <CustomFormElement
                  type="text"
                  name="company"
                  required
                  labelName={company}
                  validateOnInput
                  getValue={this.updateInputValue}
                  resetValue={resetValue}
                />
              </Column>
              <Column lg={5} lgShift={1}>
                <CustomFormElement
                  type="text"
                  name="osVersion"
                  required
                  labelName={osVersion}
                  validateOnInput
                  getValue={this.updateInputValue}
                  resetValue={resetValue}
                />
              </Column>
            </Row>
            <Row divisions={11}>
              <Column lg={11}>
                <CustomFormElement
                  type="textarea"
                  name="body"
                  labelName={messageLabel}
                  required
                  validateOnInput
                  getValue={this.updateInputValue}
                  resetValue={resetValue}
                />
              </Column>
            </Row>
            <Row divisions={15}>
              {clientSystem.map(item => (
                <Column key={item.name} lg={4} lgShift={1}>
                  <CustomCheckbox
                    name={item.name}
                    checkboxText={item.name}
                    getValue={this.updateGroupInputValue}
                    resetValue={resetValue}
                  />
                </Column>
              ))}
            </Row>
            <Row divisions={11}>
              <Column lg={11}>
                <SubmitButton centered buttonState={buttonState} />
              </Column>
            </Row>
          </Container>
        </CustomForm>
      </HTMLModifiableBackground>
    );
  }
}
ContactFormSupport.propTypes = {
  data: PropTypes.instanceOf(ContactFormSupportModel).isRequired,
};

export default ContactFormSupport;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ContactFormSupport/index.jsx